// extracted by mini-css-extract-plugin
export var arrows = "_63-6";
export var decrementer = "_63-a";
export var disabled = "_63-4";
export var error = "_63-1";
export var hiddenText = "_63-b";
export var incrementer = "_63-9";
export var input = "_63-8";
export var inputWrapper = "_63-0";
export var leadingIcon = "_63-c";
export var readonly = "_63-3";
export var regular = "_63-7";
export var small = "_63-5";
export var warning = "_63-2";